<div class="app-wrapper" (document:click)="onDocumentClick($event)">

  <!-- Header -->
  <header class="header">
    <div class="header-left">
      <div class="logo">
        <img src="/images/Acc_Dimensional_logo.png" alt="Accenture" height="28" />
      </div>
      <div class="header-divider"></div>
      <span class="header-title">{{ teamDescription }}</span>
    </div>
    <div class="header-right">
      @if (isProfileReady) {
        <div class="avatar" (click)="openUserProfile()">
          @if (userPhoto && !avatarError) {
            <img [src]="userPhoto" [alt]="userName" (error)="avatarError = true" />
          } @else {
            <span class="avatar-fallback">{{ userInitial }}</span>
          }
          <div class="avatar-info">
            <span class="avatar-name">{{ userName }}</span>
            <div class="avatar-role-row">
              <span class="avatar-role">{{ rollName }}</span>
              <button class="header-logout-btn" type="button" (click)="logout(); $event.stopPropagation()">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Logout
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </header>

  @if (isCheckingAccess) {
    <div class="access-loading">
      <div class="access-loading-spinner"></div>
      <p>Verifying access...</p>
    </div>
  } @else if (hasAccess) {
    <!-- Nav -->
    <nav class="navbar">
      <ul class="nav-list">
        @for (item of navItems; track item.name) {
          <li class="nav-item" [class.help-menu-item]="item.route[0] === '/help'">
            @if (item.route[0] === '/help') {
              <button
                type="button"
                class="nav-menu-trigger"
                [class.active]="isHelpMenuOpen || isHelpSectionActive"
                [attr.aria-expanded]="isHelpMenuOpen"
                aria-haspopup="menu"
                (click)="toggleHelpMenu()">
                {{ item.name }}
                <span class="nav-menu-chevron" aria-hidden="true"></span>
              </button>
              @if (isHelpMenuOpen) {
                <ul class="nav-submenu" role="menu">
                  <li role="none">
                    <a role="menuitem" routerLink="/help/macronize-timeline-calculator" routerLinkActive="active" (click)="closeHelpMenu()">Macronize - Timeline Calculator</a>
                  </li>
                  <li role="none">
                    <a role="menuitem" routerLink="/help/frequently-asked-questions" routerLinkActive="active" (click)="closeHelpMenu()">Frequently Asked Questions</a>
                  </li>
                </ul>
              }
            } @else {
              <a [routerLink]="item.route" routerLinkActive="active">{{ item.name }}</a>
            }
          </li>
        }
      </ul>
    </nav>

    <!-- Page content -->
    <router-outlet></router-outlet>
  } @else {
    <div class="no-access-container">
      <div class="no-access-card">
        <div class="no-access-icon">
          <img src="/images/access_denied.png" alt="Access Denied" />
        </div>
        <h2 class="no-access-title">Access Denied</h2>
        <p class="no-access-message">You don't have access to this tool.</p>
        <p class="no-access-message">Please contact the admin to get access.</p>
      </div>
    </div>
  }

  <!-- Shared Footer -->
  <!-- <footer class="footer">
    <div class="footer-links">
      <a class="footer-link">Privacy Policy</a>
      <a class="footer-link">Cookie Policy</a>
      <a class="footer-link">Terms of Use</a>
    </div>
    <span class="footer-copy">Copyright {{ currentYear }} Accenture. All rights reserved. Accenture Confidential. For internal use only.</span>
  </footer> -->
  <footer class="footer">
    <div class="footer-links">
      <a class="footer-link" href="https://in.accenture.com/protectingaccenture/5422-2/" target="_blank">Privacy Policy</a>
      <a class="footer-link" href="https://www.accenture.com/us-en/support/company-cookies-similar-technology" target="_blank">Cookie Policy</a>
      <a class="footer-link" href="" target="_blank">Terms of Use</a>
    </div>
    <span class="footer-copy">Copyright {{ currentYear }} Accenture. All rights reserved. Accenture Confidential. For internal use only.</span>
  </footer>

  @if (isProfileLoading) {
    <div class="profile-page-loader">
      <div class="profile-page-spinner"></div>
    </div>
  }

  @if (showUserProfile && !isProfileLoading) {
    <app-user-profile
      [profileData]="profileData"
      (close)="closeUserProfile()"
      (logoutRequested)="logout()">
    </app-user-profile>
  }

</div>